import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LOGO_IMAGE from '../assets/logo.png';

const SimpleHamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();

  const toggle = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  const goTo = (path) => {
    navigate(path);
    close();
    window.scrollTo(0, 0);
  };

  const menuItems = [
    { label: 'Personal Stats', path: '/stats' },
    { label: 'Leaderboard', path: '/leaderboard' },
    { label: 'Map & Check In', path: '/map' },
    { label: 'Explore Tools', path: '/tools' }
  ];

  return (
    <>
      {/* TRANSPARENT HEADER BAR */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '60px',
        backgroundColor: isOpen ? '#161d26' : 'transparent', // TRANSPARENT
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        pointerEvents: 'none' // Allow clicks through transparent areas
      }}>
        
        {/* Hamburger Button - Left */}
        <button
          onClick={toggle}
          style={{
            width: '44px',
            height: '44px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent black
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '8px',
            pointerEvents: 'auto' // Allow clicks on button
          }}
        >
          <div style={{
            width: '18px',
            height: '2px',
            backgroundColor: 'white',
            margin: '2px 0',
            transform: isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
            transition: 'all 0.3s'
          }} />
          <div style={{
            width: '18px',
            height: '2px',
            backgroundColor: 'white',
            margin: '2px 0',
            opacity: isOpen ? 0 : 1,
            transition: 'all 0.3s'
          }} />
          <div style={{
            width: '18px',
            height: '2px',
            backgroundColor: 'white',
            margin: '2px 0',
            transform: isOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
            transition: 'all 0.3s'
          }} />
        </button>

        {isOpen && (
          <img src={LOGO_IMAGE} alt='Amazon Ads' style={{
            height: '30px',
          }} />
      )}

        {/* Spacer - Right */}
        <div style={{ width: '44px' }} />
      </header>

      {/* SLIDE-OUT MENU (Only when open) */}
      {isOpen && (
        <>
          {/* Dark Overlay */}
          <div
            onClick={close}
            style={{
              position: 'fixed',
              top: '60px', // Start below header
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 99998
            }}
          />
          
          {/* Menu Panel - Slides from left */}
          <nav style={{
            position: 'fixed',
            top: '60px', // Start below header
            left: 0,
            width: window.innerWidth <= 768 ? '100%' : '280px',
            height: 'calc(100vh - 60px)',
            backgroundColor: '#000000', // Solid black menu
            zIndex: 99999,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            overflow: 'hidden'
          }}>
            {menuItems.map(item => (
              <div
                key={item.path}
                onMouseEnter={() => setHovered(item.path)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => goTo(item.path)}
                style={{
                  padding: '18px 20px',
                  backgroundColor: hovered === item.path
                    ? 'rgba(255, 255, 255, 0.25)' // WHITE highlight on hover
                    : 'rgba(255, 255, 255, 0.08)', // Light background
                  color: 'white',
                  cursor: 'pointer',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'all 0.3s ease',
                  fontSize: '16px',
                  paddingLeft: hovered === item.path ? '30px' : '20px' // Slide text effect
                }}
              >
                {item.label}
              </div>
            ))}
          </nav>
        </>
      )}
    </>
  );
};

export default SimpleHamburgerMenu;